import React from 'react';

import Resources from "../Resources";

function createColumnDefs() {
  const columnDefs = [
    { name: 'ResourceId', options: { display: true, filter: false } },
    { name: 'ClientAccountId', options: { display: false, filter: true } },
    { name: 'ResourceSubtype', label: 'Kind', options: { filter: true } },
    { name: 'Description', options: { display: true, filter: true } },
    { name: 'ResourceType', options: { display: false, filter: false } },
    { name: 'StackUpdated', options: { display: true } },
  ];
  return columnDefs;
}

export default function Streams(props) {

  const columnDefs = createColumnDefs();

  return (
    <Resources 
      type='Stream' 
      columnDefs={columnDefs} 
    />
  );
}

Streams.propTypes = {
};

Streams.defaultProps = {
};
